import { render, staticRenderFns } from "./b-ticket-travel-insurance-traveller-details.vue?vue&type=template&id=b272718e&scoped=true"
import script from "./b-ticket-travel-insurance-traveller-details.vue?vue&type=script&lang=ts&setup=true"
export * from "./b-ticket-travel-insurance-traveller-details.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./b-ticket-travel-insurance-traveller-details.vue?vue&type=style&index=0&id=b272718e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b272718e",
  null
  
)

export default component.exports